import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Navigation, Router} from "@angular/router";

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  @Input() show: boolean = true;
  @Output() showChange = new EventEmitter<boolean>();
  @Input() header = false;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  close(){
    this.showChange.emit(false);
    console.log(this.show);

  }
}
